export default {
  title: 'Estimation',
  loading: 'Chargement',
  delivery: 'Livraison',
  distance: 'Distance',
  volume: 'Volume',
  nbRooms: 'Nombre de pièces',
  box: {
    standard: 'cartons standard',
    book: 'cartons de livres',
    wardrobe: 'm de penderie',
    null: 'Pas de cartons',
  },
  rooms: 'Liste des pièces',
  elements: 'élém.',
  dates: {
    date: 'Date :',
    singleDate: 'Le {date}',
    duration: 'Entre le {date1} et le {date2}',
    specific: 'Précises',
    flexible: 'flexible',
    unknowDate: 'Pas connu',
  },
  logementType: {
    title: 'Type de logement',
    floors: 'Étages : ',
    elevator: 'Ascenseur : ',
    hardStairs: 'Esc. difficiles : ',
    mm_obligatoire: 'Monte meuble : ',
  },
  parkingArea: {
    title: 'Stationnement',
    zone: 'Zone :',
    portage: 'Portage :',
    smallTruck: 'Véhicule léger uniquement : ',
  },
  labels: {
    quantity: 'Quantité',
    volume: 'Volume',
    packaging: 'Emballage spécial',
    unpacking: 'Démontage & remontage par le déménageur',
    heavy: 'Poids > 100kg',
  },
  elevatorSize: {
    0: '1-2 personnes',
    1: '3-4 personnes',
    2: '5-6 personnes',
    3: '7-8 personnes',
  },
};
